// extracted by mini-css-extract-plugin
export default {"container":"Summary_container__Nw8n7","itemContainer":"Summary_itemContainer__v-1ct"};